<script>
import { ArticleCategory } from '@/api'
import FormMixin from '@/crudBases/form/FormMixin'
import fields from '@/components/fields/'

export default {
  mixins: [FormMixin],
  data() {
    return {
      redirectRoute: { name: 'Article Category List' }
    }
  },
  methods: {
    getFields() {
      return [
        {
          component: 'el-tabs',
          children: [this.getGeneralTab()]
        }
      ]
    },
    getGeneralTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'Ogólne'
        },
        children: [
          new fields.Input({
            label: 'Tytuł',
            modelPath: [this, 'form', 'title'],
            multilingual: true
          }),
          new fields.Input({
            label: 'Slug',
            modelPath: [this, 'form', 'slug'],
            multilingual: true,
            condition: !!this.form.id
          })
        ]
      }
    }
  },
  computed: {
    service() {
      return ArticleCategory
    }
  }
}
</script>
